var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on August 30, 2018 */\n\n\n\n@font-face {\n    font-family: 'bebas_neueregular';\n    src: url(" + escape(require("./bebasneue-regular-webfont.woff2")) + ") format('woff2'),\n         url(" + escape(require("./bebasneue-regular-webfont.woff")) + ") format('woff');\n    font-weight: normal;\n    font-style: normal;\n\n}", ""]);

// exports
